export
const name: string = "Defines";

export
const preproc: string = ``;

export
const declaration: string = `
    struct SMaterial {
        lowp vec3  ambient;
        lowp vec3  diffuse;
        lowp vec3  specular;
        lowp vec3  emissive;
        lowp float transparency;
        lowp float shininess;
        lowp int   two_sided_lighting;
        lowp float alpha;
        lowp int   shading;
        lowp vec3  texColorReadOnly;
    };
`;

export
const varyings: string = `
    #if defined(XRAY)
    varying highp float       v_intensity;
    #endif
`;

export
const implementation: string = ``;
